import * as actionCodes from '../action-type-codes';

export const saveSelectedVehicle = (vehicleDetails: any) => {
    return {
        type: actionCodes.LOBDATA_SAVE_SELECTED_VEHICLE,
        vehicleDetails
    }
}

export const saveOpAppColumnName = (columnName: any) => {
    return {
        type: actionCodes.LOBDATA_SAVE_OP_APP_COLUMN_NAME,
        columnName
    }
}

export const saveVehicleData = (vehicleData_lx: any, vehicleData_cx: any) => {
    return {
        type: actionCodes.LOBDATA_SAVE_SELECTED_VALUE,
        vehicleData_lx, vehicleData_cx
    }
}

export const setVCNumber = (lobName: any, value: any) => {
    return {
        type: actionCodes.LOBDATA_SET_VC_NO,
        lobName, value
    }
}

export const resetVCNumber = (lobName: any) => {
    return {
        type: actionCodes.LOBDATA_SET_VC_NO,
        lobName
    }
}

export const setSearchType = (searchType: any) => {
    return {
        type: actionCodes.SAVE_SEARCH_TYPE,
        searchType
    }
}

export const lobDataStateReinit = (newStateData: any) => {
    return {
        type: actionCodes.LOBDATA_STATE_REINIT,
        newStateData
    }
}

export const savePlValue = (vehiclePlValue: any, lob: any) => {
    return {
        type: actionCodes.SAVE_VEHICLE_PL,
        vehiclePlValue, lob
    }

}